"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
var _typeof = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/typeof.js");
require("core-js/modules/es6.string.iterator");
require("core-js/modules/es6.weak-map");
require("core-js/modules/es6.object.keys");
require("core-js/modules/web.dom.iterable");
require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\core-js\\modules\\es6.array.iterator.js");
require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\core-js\\modules\\es6.promise.js");
require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\core-js\\modules\\es6.object.assign.js");
require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\core-js\\modules\\es7.promise.finally.js");
var _vue = _interopRequireDefault(require("vue"));
var _jsCookie = _interopRequireDefault(require("js-cookie"));
require("normalize.css/normalize.css");
var _elementUi = _interopRequireDefault(require("element-ui"));
require("./styles/element-variables.scss");
require("quill/dist/quill.core.css");
require("@/styles/index.scss");
require("@/styles/common.css");
require("@/assets/iconfont/iconfont.css");
require("@/assets/iconfont/menuIcon.css");
require("amfe-flexible");
var _App = _interopRequireDefault(require("./App"));
var _store = _interopRequireDefault(require("./store"));
var _router = _interopRequireDefault(require("./router"));
require("./icons");
require("./permission");
var _jsMd = _interopRequireDefault(require("js-md5"));
var _index2 = _interopRequireDefault(require("@/directive/permission/index"));
require("@/libs/validate.form");
var filters = _interopRequireWildcard(require("./filters"));
var _vueDragFormdesign = _interopRequireDefault(require("vue-drag-formdesign"));
require("vue-drag-formdesign/lib/vue-drag-formdesign.css");
var _vueTreeselect = _interopRequireDefault(require("@riophae/vue-treeselect"));
require("@riophae/vue-treeselect/dist/vue-treeselect.css");
var _common2 = _interopRequireDefault(require("./libs/common.js"));
var _exportPDF = _interopRequireDefault(require("./daoPDF/exportPDF.js"));
var _vueCropper = _interopRequireDefault(require("vue-cropper"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
// a modern alternative to CSS resets

// global css
// global css
// global icon
// global icon

// icon
// permission control

_vue.default.prototype.$md5 = _jsMd.default;
// 权限指令

// global filters

// import VideoPlayer from 'vue-video-player'
// require('video.js/dist/video-js.css')
// require('vue-video-player/src/custom-theme.css')

// Vue.use(VideoPlayer)

_vue.default.use(_exportPDF.default);

// 图片裁剪工具

_vue.default.use(_vueCropper.default);
_vue.default.prototype.commonJs = _common2.default;
_vue.default.use(_index2.default);
_vue.default.use(_vueTreeselect.default);
_vue.default.use(_vueDragFormdesign.default);
_vue.default.use(_elementUi.default, {
  size: _jsCookie.default.get('size') || 'medium' // set element-ui default size
});
// hello world
// let v = window.location.hostname
// let path = v.indexOf('.')
// let provId = v.substring(0, path)

_vue.default.prototype.prCode = 'beijing';
// Vue.prototype.prCode = 'nmg'
// register global utility filters
Object.keys(filters).forEach(function (key) {
  _vue.default.filter(key, filters[key]);
});
_vue.default.config.productionTip = false;
new _vue.default({
  el: '#app',
  router: _router.default,
  store: _store.default,
  render: function render(h) {
    return h(_App.default);
  }
});